import { Pagination, PaginationProps } from "antd";
import styles from "./index.module.css";
import { CustomButton } from "../CustomButton";
import caretRight from "assets/svg/CaretRight.svg";

export const CustomPagination = (props: PaginationProps) => {
  return (
    <Pagination
      {...props}
      showQuickJumper={false}
      showSizeChanger={false}
      itemRender={(_, type, originalElem: any) => {
        if (type === "prev") {
          return (
            <CustomButton sizeButton="icon" typeButton="tertiary" disabled={originalElem.props.disabled}>
              <img
                src={caretRight}
                alt="caret right"
                style={{
                  rotate: "180deg",
                }}
              />
            </CustomButton>
          );
        } else if (type === "next") {
          return (
            <CustomButton sizeButton="icon" typeButton="tertiary" disabled={originalElem.props.disabled}>
              <img src={caretRight} alt="caret right" />
            </CustomButton>
          );
        }

        if (type === "jump-next" || type === "jump-prev") {
          return <span className={styles.ellipsis}>...</span>;
        }

        return originalElem;
      }}
      className={props.className ? props.className + " " + styles.pagination : styles.pagination}
    />
  );
};
